var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QRcode',{ref:"QRcodeRef",attrs:{"onError":_vm.error,"onSuccess":_vm.success,"workerPath":"/js/qrWork.js","config":{tipText:'Align QR code within the frame to scan' }}})}
var staticRenderFns = []

export { render, staticRenderFns }